import { useState, useEffect } from "react";
import ShimmerLoader from "../../Components/UI-Controls/Loader/ShimmerLoader";
import DataTable from "react-data-table-component";
import Pagination from "../../Components/UI-Controls/Pagination/PaginationRashid";
import MainLoader from "../../Components/UI-Controls/MainLoader/MainLoader";
import BottomToust from "../../Components/BottomToust/BottomToust";
import '../Page.css';
import { Url ,security_key} from "../../Services/Api";

const Permissions = () => {

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [uploading, setUploading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);


  const [showMessage, setShowMessage] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [showConfirm, setShowConfirm] = useState(false);

    const [filteredData, setFilteredData] = useState(data);


  const handleCloseMessageModal = () => {
    setShowMessage(false);
  };

  const rowsPerPage = 10;

  const totalPages = Math.ceil(filteredData.length / rowsPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const paginatedData = filteredData.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  useEffect(() => {
    fetchTableData();
  }, []);

  async function fetchTableData() {
    setLoading(true);
    setTimeout(async () => {
      const URL = `${Url}/api/v1/roles/get`;
      const token = sessionStorage.getItem("authToken");

      if (!token) {
        console.error("No auth token found. Please log in.");
        setLoading(false);
        return;
      }

      try {
        const response = await fetch(URL, {
          headers: {
            Authorization: `Bearer ${token}`,
            'x-api-key': security_key
          },
        });

        if (response.ok) {
          const users = await response.json();
          const Users = users.data;
          const reversedCategories = Users.reverse();

          setData(reversedCategories);
          setFilteredData(reversedCategories);
        } else if (response.status === 401) {
          console.error("Unauthorized: Invalid token.");
        
        } else {
          console.error("Error fetching data:", response.statusText);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    }, 2000);
  }

  return (
    <div className="DashboardPage">
      <div className="dashboard-card1">
        <h2>Authorization Required</h2>
        <p>Authorization Required to View Permissions</p>
      </div>
    </div>
  );
};

export default Permissions;